import React from 'react'
import {
    getHours, getMinutes, setMinutes, setHours, startOfToday, setSeconds
} from 'date-fns'
import { useField } from 'formik'
import ReactTimeField from 'react-simple-timefield'
import { Form } from 'react-bootstrap'
import styled from 'styled-components'
import { FormGroup } from 'components'
import Icon from 'components/Icon'
import { colors, _ } from 'utils'
import { padTime } from 'utils/datetime'
import { CommonFieldProps } from '../types'

const S = {
    Wrapper: styled.div`
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 44px;
        padding: 0.375rem 0.75rem;
        font-size: 14px;
        line-height: 16px;
        color: #4E5155;
        border: 1px solid rgba(24, 28, 33, 0.15);
        border-radius: 4px;
        background-clip: padding-box;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        
        input {
            width: 100% !important;
            padding-right: 20px;
            box-shadow: none !important;
            border: none !important;
            outline: none !important;
            color: inherit;
        }
        
        svg.react-time-picker__button__icon {
            stroke: #4E5155;
        }
    `,
    Icon: styled(Icon)`
        position: absolute;
        top: 33px;
        right: 20px;
    `,
    FormatInfo: styled.span`
        position: absolute;
        top: 2px;
        right: 10px;
        color: ${colors.grayTitleOpacity(0.9)};
        opacity: 0.5;
        font-size: 14px;
    `
}

const TimeField = ({
    label,
    helperText,
    isRequired,
    name,
    lg,
    md,
    sm,
    className = ''
}: CommonFieldProps) => {
    const [
        field, meta, helper
    ] = useField({ name })
    const { error, touched } = meta
    const fieldValue = field.value || startOfToday()

    const handleOnChange = (val) => {
        const times = val.target.value || '00:00'
        let newDate = fieldValue
        newDate = setHours(newDate, times.split(':')[0])
        newDate = setMinutes(newDate, times.split(':')[1])
        newDate = setSeconds(newDate, 0)
        helper.setValue(newDate)
        helper.setTouched(true)
    }

    return (
        <FormGroup
            controlId={`${field.name}-select-field`}
            lg={lg}
            md={md}
            sm={sm}
            className={`position-relative ${className}`}
        >
            <Form.Label>
                {label}
                {isRequired && <span>&nbsp;*</span>}
            </Form.Label>
            <S.Wrapper>
                <ReactTimeField
                    {...field}
                    value={`${padTime(getHours(fieldValue))}:${padTime(getMinutes(fieldValue))}`}
                    onChange={handleOnChange}
                />
            </S.Wrapper>
            <S.Icon icon="clockOutline" size={20} />
            {!(touched && error) && (
                <Form.Text muted>
                    {helperText}
                </Form.Text>
            )}
            <S.FormatInfo>
                {_('time.format_24')}
            </S.FormatInfo>
            {touched && error && <small className="text-danger invalid-field">{_(error)}</small>}
        </FormGroup>
    )
}

export default TimeField
